import ProfileRelationshipMappingAdvertisementReducer from './ProfileRelationshipMappingAdvertisementReducer';

export default from './ProfileRelationshipMappingAdvertisementContainer';
export const ProfileRelationshipMappingAdvertisementReducers = {
  ProfileRelationshipMappingAdvertisementReducer,
};
